import { useEffect, useMemo } from 'react';
import { tap } from 'rxjs';
import {
  BooleanOperator,
  Operator,
  QueryBuilderQuery,
  SearchContext,
} from '@ardoq/api-types';
import { actionNamespaceSelectParent } from '@ardoq/global-consts';
import { action$, withNamespace, ofType, dispatchAction } from '@ardoq/rxbeach';
import {
  componentSelectedInHierarchy,
  streamInitialized,
} from '../../actions/navigatorActions';
import { setParentSelectQuery } from '../../actions';

export const useDispatchWorkspaceQueryOnOpenDropdown = (
  workspaceId: string,
  componentIds: string[],
  parent: {
    id: string;
    name: string;
  } | null
) => {
  const componentIdsKey = useMemo(
    () => Array.from(new Set(componentIds)).sort().join(','),
    [componentIds]
  );
  const normalizedComponentIds = useMemo(
    () => componentIdsKey.split(',').filter(Boolean),
    [componentIdsKey]
  );
  useEffect(() => {
    const initRoutine = action$.pipe(
      withNamespace(actionNamespaceSelectParent),
      ofType(streamInitialized),
      tap(() => {
        dispatchAction(
          setParentSelectQuery({
            workspaceQuery: getWorkspaceQuery(workspaceId),
            componentIds: normalizedComponentIds,
          })
        );
        if (parent) {
          dispatchAction(
            componentSelectedInHierarchy(parent.id),
            actionNamespaceSelectParent
          );
        }
      })
    );
    const subscription = initRoutine.subscribe();
    return () => subscription.unsubscribe();
  }, [workspaceId, normalizedComponentIds, parent]);
};

const getWorkspaceQuery = (workspaceId: string): QueryBuilderQuery => {
  return {
    condition: BooleanOperator.AND,
    rules: [
      {
        field: 'type',
        id: 'type',
        input: 'select',
        operator: Operator.EQUAL,
        type: 'string',
        value: SearchContext.COMPONENT,
      },
      {
        condition: BooleanOperator.AND,
        rules: [
          {
            id: 'rootWorkspace',
            field: 'rootWorkspace',
            input: 'text',
            type: 'string',
            operator: Operator.EQUAL,
            value: workspaceId,
          },
        ],
      },
    ],
  };
};
